export default {
  每月: "Monthly",
  季度: "Quarterly",
  全年: "Annual",
  計算: "Calculation",
  新公司計算器: "Calculator for setting up a company",
  "2020所得補充稅模擬計算": "2021 - 2022 Profits Tax Calculation",
  "2021個人職業所得稅計算器":
    "2023 Personal Professional Income Tax Calculator",
  計算年度: "Ano do cálculo",
  "65歲以下": "Under the age of 65",
  "2021年度剛滿65歲": "Just reached the age of 65 in the year of 2022",
  "65歲以上/殘疾人士": "Over the age of 65 / Disabled persons",
  "A.每月總收益（包括不課稅收益）":
    "A.Gross monthly income (non-taxable income included)",
  "A.季度總收益（包括不課稅收益）":
    "A.Gross quarterly income (non-taxable income included)",
  "A.全年總收益（包括不課稅收益）":
    "A.Gross annual income (non-taxable income included)",
  "B.不屬課稅收益": "B.Non-taxable income",
  "C.固定扣除，相當於對B項扣減後之工作收益之25%":
    "C.Fixed deduction equivalent to 25% of the income amount after deduction of B ((A-B) x 25%)",
  "D.每月可課稅收益": "D.Monthly taxable income (A - B - C)",
  "D.季度可課稅收益": "D.Quarterly taxable income (A - B - C)",
  "D.全年可課稅收益": "D.Annual taxable income (A - B - C)",
  出生年份: "Year Of Birth",
  時間: "Time",
  註冊資本: "Registered Capital",
  由: "From",
  至: "To",
  稅率: "Tax Rate",
  該級可課稅收益: "Taxable Income under each tier",
  可課稅收益: "Taxable Income ",
  該級稅款: "Tax amount under each tier",
  累計稅款: "Accumulated tax amount",
  根據法定稅率計出之每月稅款:
    "E.Monthly tax amount calculated based upon the statutory tax rates",
  根據法定稅率計出之季度稅款:
    "E.Quarterly tax amount calculated based upon the statutory tax rates",
  根據法定稅率計出之全年稅款:
    "E.Annual tax amount calculated based upon the statutory tax rates",
  "根據有關年度財政預算案對職業稅稅額之30%扣減優惠":
    "F.30% wavier of the salaries tax according to the tax relief measures as announced in the government budget of relevant financial year(s). (E x 30%)",
  每月應繳職業稅稅款: "G.Monthly salaries tax payable (E - F) ",
  季度應繳職業稅稅款: "G.Quarterly salaries tax payable (E - F) ",
  全年應繳職業稅稅款: "G.Annual salaries tax payable (E - F) ",
  "(1)計算結果僅供參考。而確定性可課稅金額以稅務當局所作之評定為準。":
    "(1)The result of the above calculation is for reference only. The finalized amount of taxable income is subject to the evaluation of the tax administration.",
  "(2)不足一元的部分，作一元計。":
    "(2)The amount will be rounded up to the nearest dollar.",
  "(3)不足一元的部分，作一元計。":
    "(3)The amount will be rounded up to the nearest dollar.",
  "B.應繳所得補充稅稅款": "B. Profits Tax Payable",
  "A. 年度之可課稅收益": "A. Annual Taxable Income",
  "(2)僅適用於2020年度取得的收益。":
    "(2)Only applicable to the income acquired in 2020.",
  "Must greater than or equal to 25000.":
    "Must greater than or equal to 25000.",

  simpleVueValidator_required: "Required",
  simpleVueValidator_integer: "Input value must be integer",
  simpleVueValidator_greaterThenZero: "The relevant number cannot be negative",
  simpleVueValidator_over_three_million: "Over three million",
  stamp_duty_transfer: "Stamp Duty(Conveyance of Property) Calculation",
  bought_value: "Purchase Value",
  mop: "MOP",
  house_record_value: "Property Record Value",
  please_input_int_amt: "Please input integral value in the cell.",
  confirm_transfer: "Definite Conveyance",
  confirm_middle_transfer:
    "Definite Conveyance(after completion of intermediate conveyance)",
  from: "From",
  till: "To",
  tax_rate: "Tax Rate",
  tax_amt: "Taxable Amount",
  level_tax: "Tax amount under each",
  sub_tax_amt: "Accumulated tax amount",
  property_transfer_stamp_duty: "Stamp duty on Property conveyance",
  voucher_stamp_duty: "Stamp duty on document",
  total_tax_amt: "Total Tax Payable",
  calculate: "Calculate",
  ahead_1: "over ",
  ahead_2: "",
  remark_1:
    "The result of the above calculation is for reference only. The finalized taxable amount is subject to the evaluation of the tax administration.",
  remark_2: "The amount will be rounded up to the nearest dollar.",
  remark_3:
    "The tax rate that is applicable to the taxable income of a leased property is 8%.",
  remark_3_1:
    "The tax rate that is applicable to the taxable income of a non-leased property is 6%.",
  transfer_real_estate_stamp_duty:
    "Special Stamp Duty (conveyance of property) Calculation",
  sale_value: "Sale value",
  calculate_transfer_stamp_duty_from_one_year:
    "Conveyance within one year from the settlement date of stamp duty upon purchase of property",
  calculate_transfer_stamp_duty_from_two_year:
    "Conveyance exceeding one year but within two years from the settlement date of stamp duty upon purchase of property",
  house_tax_calculator: "2020 - 2022 Property Tax Calculation",
  house_for_rent: "Rental property",
  house_not_for_rent: "Non-Rental property",
  if_macau_id_holder:
    "If the proprietor is the holder of a Macao Resident Identity Card?",
  please_select: "Please select",
  yes: "Yes",
  no: "No",
  real_estate_type: "Real Estate Type",
  residential: "Residential",
  business:
    "Hotels and similar activities, office buildings, commercial and industrial uses",
  other: "Other",
  rent_value: "Annual rent",
  M7_manage_value:
    "Amount declared in 'House Tax-Maintenance and Management Cost M/7' : ",
  tax_revenue: "Estimated Annual Rental Value",
  tax: "Tax amount",
  except_house_tax:
    "A preferential deduction on Property Tax according to the tax relief measures as announced in the government budget of relevant financial year(s)",
  rent_stamp_duty: "Lease stamp duty",
  expect_rent_value: "Estimated Annual Rental Value",
  company_tax_calculate: "Calculation Table for Enterprise Income Tax",
  company_type: "Type of enterprise",
  normal_company: "Ordinary Enterprises",
  non_resident_company: "Non-resident Enterprises",
  high_tech_company:
    "Macao funded enterprises eligible to establish in Guangdong and High Technology Enterprises",
  low_profit_company: "Small and Low-Profit Enterprises",
  expect_tax_value: "Taxable Income",
  expect_personal_tax: "Personal taxable income",
  personal_tax: "Individual income tax",
  company_tax: "Enterprise Income Tax",
  over_one_million: "<= 1,000,000",
  between_one_million_and_three_million: "1,000,000<Taxable Income<=3,000,000",
  needed_tax: "Income Tax",
  remark: "Obs.",
  remark_6:
    "According to the 'Enterprise Income Tax Law of the People's Republic of China',  a non-resident enterprise having no office or establishment inside China, or for a non-resident enterprise whose incomes have no actual connection to its institution(s) or establishment(s) inside China, it must pay the enterprise income tax on the incomes derived from China.",
  remark_7:
    "According to the  'Notice on Implementing the Policy of Inclusive Tax Relief for Small and Micro Enterprises', small and low-profit enterprise refers to an enterprise that engages in any industry not restricted or prohibited by the state, and its annual taxable income is ",
  remark_7_1: "not more than RMB 3 million",
  remark_7_2: "; the number of its employees is ",
  remark_7_3: "not more than 300",
  remark_7_4: ", and its total assets ",
  remark_7_5: "do not exceed RMB 50 million",
  remark_7_6: ".",
  remark_8:
    "Preferential Income Tax Policie for small and low-profit enterprises are currently valid until ",
  remark_8_1: "December 31, 2021",
  remark_8_2: ".",
  disclaimer1:
    "Taxable income shown on the above table is the amount subjected according to the country's taxation requirement.",
  disclaimer2:
    "The above calculation table is for reference only.  It does not reflect the tax imposition/assessment of the authorities concerned and accredited accountants.",
  personal_tax_calculate: "Individual Income Tax Calculator",
  personal_tax_per_year:
    "Individual Income Tax Calculator (Applicable to the annual consolidated income for resident individuals)",
  personal_tax_per_year_non_chinese:
    "Individual Income Tax Calculator (Applicable to the monthly/single-payment consolidated income for non-resident individuals)",
  personal_tax_company:
    "Individual Income Tax Calculation Table (applicable to business income)",
  personal_tax_other:
    "Individual Income Tax Calculator (applicable to income from interest, dividends, bonuses, lease and transfer of property, and contingent income).",
  remark_personal_per_year_1:
    "Pursuant to the Individual Income Tax Law of the People’s Republic of China, the consolidated income of resident individuals comprises wages and salaries, services remuneration, manuscript remuneration and royalties. 80% of income from services remuneration, manuscript remuneration and royalties is considered taxable income, whereas 70% of income from manuscript remuneration is taxable.",
  remark_personal_1:
    "Resident individuals are those who have a domicile in the territory of China, or those who do not have a domicile but reside in China for a total of 183 days or more in a tax year. Resident individuals are required to pay the individual income tax for income derived within and outside the territory of China. Non-resident individuals are those who neither have a domicile nor reside in China, or those who do not have a domicile but live in China for a total of less than 183 days in a tax year. Non-resident individuals must pay the individual income tax for income derived in the territory of China as stipulated by law.",
  remark_personal_non_chinese:
    "Pursuant to the Individual Income Tax Law of the People’s Republic of China, the consolidated income of resident individuals comprises wages and salaries, services remuneration, manuscript remuneration and royalties. 80% of income from services remuneration, manuscript remuneration and royalties is considered taxable income, whereas 70% of income from manuscript remuneration is taxable.",
  remark_personal_disclaimer:
    "Deductions are not taken into account in this calculator, and the calculation results are for reference only.",
  revenue_year: "Revenue (annual total)",
  cost_year: "Costs (annual total)",
  expense_year: "Expenses (annual total)",
  loss_year: "Losses (annual total)",
  CEL_year: "Costs、Expenses、Losses(annual total)",
  remark_personal_company:
    "Applicable to income obtained by individual businesses from production, business activities, contracted or leasehold business operation for enterprises or public institutions).",
  unit_RMB: "Currency: RMB",
  dividends: "Interest, dividends and bonuses",
  property_for_rent: "Lease of property",
  property_for_transfer: "Transfer of property",
  property_transfer_revenue: "Income from property transfer",
  property_origin_amount: "Original value of property",
  reasonable_expense: "Reasonable expenses",
  incident_income: "Contingent income",
  total: "Total",
  disclaimer_GBP_1:
    "For details of individual income tax deductions, exemptions and reductions that are not covered on this page, please refer to the relevant policy and documents.",
  disclaimer_GBP_2:
    "The results from this calculator are for reference only. To perform specific obligations of tax declaration and complete payment, please follow the national taxation laws, regulations, provisions and regulatory documents.",
  disclaimer_GBP_3:
    "The above calculators are for reference only. They do not reflect the tax imposition/assessment of the authorities concerned and accredited accountants.",
  total_income_amount: "Consolidated income",
  salary_income: "Wages and salaries",
  remuneration_income: "Services remuneration",
  manuscript_income: "Manuscript remuneration",
  royalties_income: "Royalties",
  social_insurance: "Various social insurance payments ",
  deductions:
    "Special additional deductions and other deductions regulated by the law",
  per_month: "per month",
  per_time: "per payment",
  tax_amount: "Tax payable",
  register_capital_limit_25000:
    "The minimum capital Volume is MOP$25,000.00, and there is no upper limit",
  notarization_fee: "Notary Fees",
  notarial_stamp_duty_2021:
    "Stamp Tax of Notarial Deed(Effective March 31, 2021)",
  registration_certificate_fee: "Name Registration(Per time)MOP 65",
  company_registration: "Company Registration",
  main_cost_setup_company: "The main cost of setting up a company is about",
  simpleVueValidator_can_divided_by_100: "Must be a multiple of 100",
  simpleVueValidator_only_year:
    "Please input date of birth, format: year/month/day",
  above: "above",
  incomeTax_discount:
    "Waiver of profits tax according to the tax relief measures as announced in the government budget of the relevant financial year (up to a maximum of $300,000)",
  incomeTax_allYear: "Annual profits tax payable (B – C)",
};
